<template>
    <div class="quick-select-wrap" id="quick-select-wrap">
        <ul class="quick-select-ul">
            <li class="clear" @click="selectItems('')">
                <p>清空发言</p>
            </li>
            <li v-for="(normal, nindex) in quickData.normal"
                :key="nindex"
                @click="selectItems(normal)"
            >
                <p> {{ normal }}</p>
            </li>
            <li v-for="(tactic, tindex) in quickData.tactic"
                :key="tindex"
                class="special"
                @click="selectItems(tactic)"
            >
                <p>{{ tactic }}</p>
            </li>
        </ul>
    </div>
</template>

<script>
    import BScroll from '@better-scroll/core';
    import { getSayHTML } from "@/common/fns";
    import { postSay } from "@/api/post";

    let bScroll = null;

    export default {
        name: "quick-say-menu",
        props: {
            quickData: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        methods: {
            async selectItems(text) {
                const content = getSayHTML.normal(text);
                const myname = window.setting.userInfo.username;
                const result = await postSay(myname, content);
                console.log(result)
            }
        },
        watch: {
            quickData: {
                handler() {
                    console.log('quicksay watching')
                    this.$nextTick(() => {
                        if(bScroll) {
                            bScroll.refresh();
                        } else {
                            const wrapper = document.getElementById('quick-select-wrap');
                            bScroll = new BScroll(wrapper, {
                                click: true
                            });
                        }
                    });
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
